import * as tf from '@tensorflow/tfjs'
import * as blazeface from '@tensorflow-models/blazeface'
// import '@tensorflow/tfjs-backend-wasm';

class LowPassFilter {
  constructor(alpha) {
    this.setAlpha(alpha);
    this.y = null;
    this.s = null;
  }
  
  setAlpha(alpha) {
    if (alpha <= 0 || alpha > 1.0) {
      throw new Error();
    }
    this.alpha = alpha;
  }
  
  filter(value, timestamp, alpha) {
    if (alpha) {
      this.setAlpha(alpha);
    }
    let s;
    if (!this.y) {
      s = value;
    } else {
      s = this.alpha * value + ( 1.0 - this.alpha ) * this.s;
    }
    this.y = value;
    this.s = s;
    return s;
  }
  
  lastValue() {
    return this.y;
  }
}

class OneEuroFilter {
  constructor(freq, minCutOff=1.0, beta=0.0, dCutOff=1.0) {
    if (freq <= 0 || minCutOff <= 0 || dCutOff <= 0) {
      throw new Error();
    }
    this.freq = freq;
    this.minCutOff = minCutOff;
    this.beta = beta;
    this.dCutOff = dCutOff;
    this.x = new LowPassFilter(this.alpha(this.minCutOff));
    this.dx = new LowPassFilter(this.alpha(this.dCutOff));
    this.lasttime = null;
  }
  
  alpha(cutOff) {
    const te = 1.0 / this.freq;
    const tau = 1.0 / ( 2 * Math.PI * cutOff );
    return 1.0 / ( 1.0 + tau / te );
  }
  
  filter(x, timestamp=null) {
    if (this.lasttime && timestamp) {
      this.freq = 1.0 / ( timestamp - this.lasttime );
    }
    this.lasttime = timestamp;
    const prevX = this.x.lastValue();
    const dx = (!prevX) ? 0.0 : ( x - prevX ) * this.freq;
    const edx = this.dx.filter(dx, timestamp, this.alpha(this.dCutOff));
    const cutOff = this.minCutOff + this.beta * Math.abs(edx);
    return this.x.filter(x, timestamp, this.alpha(cutOff));
  }
}

const Fer = (function () {
 
  // Instance stores a reference to the Singleton
  var instance
 
  function init() {
 
    // Singleton
    // Private variables
    let is_ready = false
    const boxInd = [0]
    const xScale = 1.25
    const yScale = 1.25

    const filters = [...Array(8).keys()].map(() => new OneEuroFilter(30, 0.8, 0.00000001, 0.5))

    // old model
    // const rgbWeights = tf.tensor([0.2989, 0.5870, 0.1140])
    // const model_json = '/old_model/model.json'
    // const cropSize = [48, 48]
    // const labels = ['neutral', 'anger', 'disgust', 'fear', 'happy', 'sadness', 'surprise']

    // eff model
    // const labels = ['neutral','smile','sadness','surprised','fear','disgust','anger']
    // const mean = tf.tensor([0.57535914, 0.44928582, 0.40079932])
    // const std = tf.tensor([0.20735591, 0.18981615, 0.18132027])
    // const model_json = '/eff_model/model.json'
    // const cropSize = [224, 224]
    // const labels = ['neutral','smile','scream','surprised','scream','disgust','scream']

    // model
    // const labels = ['neutral', 'smile', 'surprised', 'squint', 'disgust', 'scream']
    // const model_json = '/model/model.json'
    // const cropSize = [192, 192]
    // const labels = ['neutral', 'smile', 'surprised', 'disgust', 'disgust', 'scream']


    // new model
    // const labels = ['neutral', 'smile', 'surprised', 'squint', 'disgust', 'scream']
    const model_json = '/model_new/model.json'
    const cropSize = [224, 224]
    const labels = ['surprised','disgust','smile','scream','neutral']


    let bfModel = undefined
    let ferModel = undefined

    function argMax(array) {
      return [].reduce.call(array, (m, c, i, arr) => c > arr[m] ? i : m, 0)
    }

    // Private method
    async function loadModel() {
        if(!is_ready){
          ferModel = await tf.loadGraphModel(model_json)
          bfModel = await blazeface.load()
          is_ready = true
        }
    }

    // Private method
    async function rectToExpression(normBox, video, rad, center) {
        const tfId = tf.tidy(() => {
            // get video from element
            let tfImage = tf.browser.fromPixels(video)

            tfImage = tf.expandDims(tf.cast(tfImage, 'float32'), 0)
            tfImage = tf.image.rotateWithOffset(tfImage, rad, 0, center)

            // normalize, resize and crop
            tfImage = tf.image.cropAndResize(tfImage, [normBox], boxInd, cropSize)
            tfImage = tf.div(tfImage, 255)

            // from rgb to grayscale for old model
            // tfImage = tf.mul(tfImage, rgbWeights)
            // tfImage = tf.sum(tfImage, -1, true)

            // use fer model to predict expression
            const ferPrediction = ferModel.predict(tfImage)
            return tf.argMax(ferPrediction)
        })
        const id = tfId.dataSync()
        tfId.dispose()
        return Array.from(id)[0]
    }

    async function rectToLogits(normBox, video, rad, center) {
      const tfId = tf.tidy(() => {
          // get video from element
          let tfImage = tf.browser.fromPixels(video)

          tfImage = tf.expandDims(tf.cast(tfImage, 'float32'), 0)
          tfImage = tf.image.rotateWithOffset(tfImage, rad, 0, center)

          // normalize, resize and crop
          tfImage = tf.image.cropAndResize(tfImage, [normBox], boxInd, cropSize)
          tfImage = tf.div(tfImage, 255)

          // from rgb to grayscale for old model
          // tfImage = tf.mul(tfImage, rgbWeights)
          // tfImage = tf.sum(tfImage, -1, true)

          // use fer model to predict expression
          return ferModel.predict(tfImage)
      })
      const logits = tfId.dataSync()
      tfId.dispose()
      return Array.from(logits)
  }

    async function rectToExpression_eff(normBox, video, rad, center) {
        const tfId = tf.tidy(() => {
            // get video from element
            let tfImage = tf.browser.fromPixels(video)

            tfImage = tf.expandDims(tf.cast(tfImage, 'float32'), 0)
            tfImage = tf.image.rotateWithOffset(tfImage, rad, 0, center)

            // normalize, resize and crop
            tfImage = tf.image.cropAndResize(tfImage, [normBox], boxInd, cropSize)
            tfImage = tf.div(tfImage, 255)

            // eff model
            tfImage = tf.sub(tfImage, mean)
            tfImage = tf.div(tfImage, std)
            tfImage = tfImage.transpose([0, 3, 1, 2])

            return tfImage
        })
        const ferPrediction = await ferModel.executeAsync({input: tfId})
        const data = ferPrediction.dataSync()
        const result = argMax(Array.from(data))

        ferPrediction.dispose()
        tfId.dispose()

        return result
    }

    // Private method
    function getRadCenter(prediction, width, height) {
      const center = [
        (prediction.topLeft[0] + prediction.bottomRight[0]) / (2 * width),
        (prediction.topLeft[1] + prediction.bottomRight[1]) / (2 * height)
      ]

      const rightEye = prediction.landmarks[0]
      const leftEye = prediction.landmarks[1]
      const dX = rightEye[0] - leftEye[0]
      const dY = rightEye[1] - leftEye[1]
      const rad = - Math.atan2(dX, dY) - Math.PI / 2

      return [rad, center]
    }

    function filter(prediction) {
      prediction.topLeft[0] = filters[0].filter(prediction.topLeft[0]);
      prediction.topLeft[1] = filters[1].filter( prediction.topLeft[1]);
      prediction.bottomRight[0] = filters[2].filter(prediction.bottomRight[0]);
      prediction.bottomRight[1] = filters[3].filter(prediction.bottomRight[1]);
      prediction.landmarks[0][0] = filters[4].filter(prediction.landmarks[0][0]);
      prediction.landmarks[0][1] = filters[5].filter(prediction.landmarks[0][1]);
      prediction.landmarks[1][0] = filters[6].filter(prediction.landmarks[1][0]);
      prediction.landmarks[1][1] = filters[7].filter(prediction.landmarks[1][1]);
      return prediction
    }

    function predictionToRect(prediction, image_width, image_height) {
        const xMin = prediction.topLeft[0]
        const yMin = prediction.topLeft[1]
        const xMax = prediction.bottomRight[0]
        const yMax = prediction.bottomRight[1]

        const xCenter = (xMin + xMax) / 2
        const yCenter = (yMin + yMax) / 2

        let rect_width = xMax - xMin
        let rect_height = yMax - yMin
        const longSide = Math.max(rect_width, rect_height)
        rect_width = xScale * longSide
        rect_height = yScale * longSide

        const box = [yCenter - rect_height / 2, // y1
                     xCenter - rect_width / 2,  // x1
                     yCenter + rect_height / 2, // y2
                     xCenter + rect_width / 2]  // x2

        const normBox = [box[0] / image_height,
                         box[1] / image_width,
                         box[2] / image_height,
                         box[3] / image_width]

        return normBox
    }

    return {
      // Public variables
      is_ready: () => is_ready,
      // Public methods
      getFaceEstimate: async function(video, canvas, width, height) {
        const predictions = await bfModel.estimateFaces(video, false)

        if(predictions.length > 0) {
          const prediction = filter(predictions[0])
          const normBox = predictionToRect(prediction, width, height);
          const [rad, center] = getRadCenter(prediction, width, height);

          const tfId = tf.tidy(() => {
            // get video from element
            let tfImage = tf.browser.fromPixels(video)

            tfImage = tf.expandDims(tf.cast(tfImage, 'float32'), 0)
            tfImage = tf.image.rotateWithOffset(tfImage, rad, 0, center)

            // normalize, resize and crop
            tfImage = tf.image.cropAndResize(tfImage, [normBox], boxInd, cropSize)
            tfImage = tf.div(tfImage, 255)

            return tfImage.squeeze();
          });
          tf.browser.toPixels(tfId, canvas)
          tfId.dispose();

          return predictions;
        } else {
          return undefined
        }
      },
      getLogits: async function (video, width, height) {
        const predictions = await bfModel.estimateFaces(video, false)
        if(predictions.length > 0) {
          const prediction = filter(predictions[0])
          const normBox = predictionToRect(prediction, width, height)
          const [rad, center] = getRadCenter(prediction, width, height);
          const logits = await rectToLogits(normBox, video, rad, center)
          return logits
        } else {
            return undefined
        }
    },
      getExpression: async function (video, width, height) {
          const predictions = await bfModel.estimateFaces(video, false)
          if(predictions.length > 0) {
            const prediction = filter(predictions[0])
            const normBox = predictionToRect(prediction, width, height)
            const [rad, center] = getRadCenter(prediction, width, height);
            const labelId = await rectToExpression(normBox, video, rad, center)
            return labels[labelId]
          } else {
              return undefined
          }
      },
      // setupTfWasm: async function() {
      //   return tf.setBackend('wasm').then(loadModel);
      // },
      setupTf: async function() {
        return tf.ready().then(loadModel)
      },
    }
 
  }
 
  return {
 
    // Get the Singleton instance if one exists
    // or create one if it doesn't
    getInstance: function () {
 
      if ( !instance ) {
        instance = init()
      }
 
      return instance
    }
 
  }
 
})()

export default Fer